
import { Alert } from './Alert';
import { fakeAlerts } from '../user-interface/Alerts/fakeAlerts';
function generateSensorHistory(
  temperatureMin: number,
  temperatureMax: number,
  humidityMin: number,
  humidityMax: number
): SensorReading[] {
  const readings: SensorReading[] = [];
  const startDate = new Date('2025-07-17T00:00:00.000Z');
  const endDate = new Date();
  const count = Math.round((endDate.getTime() - startDate.getTime()) / (2 * 60 * 1000));

  for (let i = 0; i < count; i++) {
    const date = new Date(startDate.getTime() + i * 2 * 60 * 1000);

    readings.push({
      timestamp: date.toISOString(),
      temperature:
        Math.round(
          (Math.random() * (temperatureMax - temperatureMin) + temperatureMin) * 10
        ) / 10,
      humidity:
        Math.round(
          (Math.random() * (humidityMax - humidityMin) + humidityMin) * 10
        ) / 10,
    });
  }

  return readings;
}

export interface DoorSensorReading {
  timestamp: string;
  ouvert: boolean;
}

export interface SensorReading {
  timestamp: string;
  temperature: number;
  humidity: number;
}

export interface DoorSensorData {
  macAddr: string;
  label: string;
  rssi: number;
  battery: number;
  lastSeen: string;
  ouvert: boolean;
  alertes: boolean;
  rapports: boolean;
  actif: boolean;
  historique: DoorSensorReading[];
  alertesList?: Alert[];
}


export interface SensorData {
  macAddr: string;
  label: string;
  rssi: number;
  temperature: number;
  humidity: number;
  battery: number;
  temperatureMin: number;
  temperatureMax: number;
  humidityMin: number;
  humidityMax: number;
  alertDelay: number;
  lastSeen: string;
  alertes: boolean;
  rapports: boolean;
  actif: boolean;
  historique: SensorReading[];
  alertesList?: Alert[];
  // New fields for engin data compatibility
  tagname?: string;
  uid?: string;
  id?: string;
  title?: string;
  reference?: string;
  name?: string;
}



export const fakeDoorSensors: DoorSensorData[] = [
  {
    macAddr: "ZZ:YY:XX:WW:VV:01",
    label: "Porte Entrée",
    rssi: -40,
    battery: 90,
    lastSeen: "2025-07-17T12:00:00Z",
    ouvert: false,
    alertes: false,
    rapports: true,
    actif: true,
    historique: generateDoorSensorHistory(new Date('2025-07-17T00:00:00.000Z'), 2 * 60 * 1000, 144, false)
  },
  {
    macAddr: "ZZ:YY:XX:WW:VV:02",
    label: "Porte Sortie",
    rssi: -40,
    alertesList: fakeAlerts.filter(a => a.sensorMacAddr === "ZZ:YY:XX:WW:VV:02"),
    battery: 90,
    lastSeen: "2025-07-17T12:00:00Z",
    ouvert: false,
    alertes: false,
    rapports: true,
    actif: true,
    historique: generateDoorSensorHistory(new Date('2025-07-17T00:00:00.000Z'), 2 * 60 * 1000, 144, true)
  },
  {
    macAddr: "ZZ:YY:XX:WW:VV:03",
    label: "Porte Bureau",
    rssi: -40,
    battery: 90,
    lastSeen: "2025-07-17T12:00:00Z",
    ouvert: false,
    alertes: false,
    rapports: true,
    actif: true,
    historique: generateDoorSensorHistory(new Date('2025-07-17T00:00:00.000Z'), 2 * 60 * 1000, 144, false)
  },
  {
    macAddr: "ZZ:YY:XX:WW:VV:04",
    label: "Porte Cuisine",
    rssi: -40,
    alertesList: fakeAlerts.filter(a => a.sensorMacAddr === "ZZ:YY:XX:WW:VV:04"),
    battery: 90,
    lastSeen: "2025-07-17T12:00:00Z",
    ouvert: false,
    alertes: false,
    rapports: true,
    actif: true,
    historique: generateDoorSensorHistory(new Date('2025-07-17T00:00:00.000Z'), 2 * 60 * 1000, 144, true)
  },
];

function generateDoorSensorHistory(startDate: Date, interval: number, count: number, alternate: boolean): DoorSensorReading[] {
  const readings: DoorSensorReading[] = [];

  for (let i = 0; i < count; i++) {
    const date = new Date(startDate.getTime() + i * interval);

    readings.push({
      timestamp: date.toISOString(),
      ouvert: alternate ? i % 2 === 0 : i % 2 === 1
    });
  }

  return readings;
}

export const fakeSensors: SensorData[] = [
  {
    macAddr: "AA:BB:CC:DD:EE:01",
    label: "Capteur Salon",
    rssi: -45,
    temperature: 22.5,
    humidity: 45.2,
    battery: 85,
    temperatureMin: -5.0,
    temperatureMax: 10.0,
    humidityMin: 30.0,
    humidityMax: 60.0,
    alertDelay: 30,
    lastSeen: "2025-07-14T10:30:00Z",
    alertes: false,
    rapports: true,
    actif: true,
    historique: generateSensorHistory(-5.0, 18.0, 30.0, 60.0)
  },
  {
    macAddr: "AA:BB:CC:DD:EE:02",
    label: "Capteur Chambre",
    rssi: -55,
    alertesList: fakeAlerts.filter(a => a.sensorMacAddr === "AA:BB:CC:DD:EE:02"),
    temperature: 24.1,
    humidity: 52.8,
    battery: 92,
    temperatureMin: -5.0,
    temperatureMax: 18.0,
    humidityMin: 40.0,
    humidityMax: 70.0,
    alertDelay: 30,
    lastSeen: "2024-07-16T10:25:00Z",
    alertes: true,
    rapports: true,
    actif: true,
    historique: generateSensorHistory(-5.0, 18.0, 40.0, 70.0)
  },
  {
    macAddr: "AA:BB:CC:DD:EE:03",
    label: "Capteur Etage 1",
    rssi: -68,
    temperature: 19.8,
    humidity: 38.5,
    battery: 23,
    temperatureMin: -5.0,
    temperatureMax: 18.0,
    humidityMin: 30.0,
    humidityMax: 50.0,
    alertDelay: 30,
    lastSeen: "2024-07-16T09:15:00Z",
    alertes: true,
    rapports: false,
    actif: false,
    historique: generateSensorHistory(-5.0, 18.0, 30.0, 50.0)
  },
  {
    macAddr: "AA:BB:CC:DD:EE:04",
    label: "Capteur Frigo",
    rssi: -68,
    temperature: 19.8,
    humidity: 38.5,
    battery: 23,
    temperatureMin: -5.0,
    temperatureMax: 18.0,
    humidityMin: 30.0,
    humidityMax: 50.0,
    alertDelay: 30,
    lastSeen: "2024-07-16T09:15:00Z",
    alertes: true,
    rapports: false,
    actif: false,
    historique: generateSensorHistory(-5.0, 18.0, 30.0, 50.0)
  },
  {
    macAddr: "AA:BB:CC:DD:EE:05",
    label: "Capteur Salle de bain",
    rssi: -68,
    temperature: 19.8,
    humidity: 38.5,
    battery: 23,
    temperatureMin: -5.0,
    temperatureMax: 18.0,
    humidityMin: 30.0,
    humidityMax: 50.0,
    alertDelay: 30,
    lastSeen: "2024-07-16T09:15:00Z",
    alertes: true,
    rapports: false,
    actif: false,
    historique: generateSensorHistory(-5.0, 18.0, 30.0, 50.0)
  },
  {
    macAddr: "AA:BB:CC:DD:EE:06",
    label: "Capteur Salle de douche",
    rssi: -68,
    temperature: 19.8,
    humidity: 38.5,
    battery: 23,
    temperatureMin: -5.0,
    temperatureMax: 18.0,
    humidityMin: 30.0,
    humidityMax: 50.0,
    alertDelay: 30,
    lastSeen: "2024-07-16T09:15:00Z",
    alertes: true,
    rapports: false,
    actif: false,
    historique: generateSensorHistory(-5.0, 18.0, 30.0, 50.0)
  },
  {
    macAddr: "AA:BB:CC:DD:EE:07",
    label: "Capteur Chambre Froide",
    rssi: -68,
    temperature: 19.8,
    humidity: 38.5,
    battery: 23,
    temperatureMin: -5.0,
    temperatureMax: 18.0,
    humidityMin: 30.0,
    humidityMax: 50.0,
    alertDelay: 30,
    lastSeen: "2024-07-16T09:15:00Z",
    alertes: true,
    rapports: false,
    actif: false,
    historique: generateSensorHistory(-5.0, 18.0, 30.0, 50.0)
  },
  {
    macAddr: "AA:BB:CC:DD:EE:08",
    label: "Capteur Garage",
    rssi: -68,
    temperature: 19.8,
    humidity: 38.5,
    battery: 23,
    temperatureMin: -5.0,
    temperatureMax: 18.0,
    humidityMin: 30.0,
    humidityMax: 50.0,
    alertDelay: 30,
    lastSeen: "2024-07-16T09:15:00Z",
    alertes: true,
    rapports: false,
    actif: false,
    historique: generateSensorHistory(-5.0, 18.0, 30.0, 50.0)
  },
  {
    macAddr: "AA:BB:CC:DD:EE:09",
    label: "Capteur Voiture",
    rssi: -68,
    temperature: 19.8,
    humidity: 38.5,
    battery: 23,
    temperatureMin: -5.0,
    temperatureMax: 18.0,
    humidityMin: 30.0,
    humidityMax: 50.0,
    alertDelay: 30,
    lastSeen: "2024-07-16T09:15:00Z",
    alertes: true,
    rapports: false,
    actif: false,
    historique: generateSensorHistory(-5.0, 18.0, 30.0, 50.0)
  },
  {
    macAddr: "AA:BB:CC:DD:EE:09",
    label: "Capteur Jardin",
    rssi: -68,
    temperature: 19.8,
    humidity: 38.5,
    battery: 23,
    temperatureMin: -5.0,
    temperatureMax: 18.0,
    humidityMin: 30.0,
    humidityMax: 50.0,
    alertDelay: 30,
    lastSeen: "2024-07-16T09:15:00Z",
    alertes: true,
    rapports: false,
    actif: false,
    historique: generateSensorHistory(-5.0, 18.0, 30.0, 50.0)
  },
  {
    macAddr: "AA:BB:CC:DD:EE:09",
    label: "Capteur Ambiant Intérieur",
    rssi: -68,
    temperature: 19.8,
    humidity: 38.5,
    battery: 23,
    temperatureMin: -5.0,
    temperatureMax: 18.0,
    humidityMin: 30.0,
    humidityMax: 50.0,
    alertDelay: 30,
    lastSeen: "2024-07-16T09:15:00Z",
    alertes: true,
    rapports: false,
    actif: false,
    historique: generateSensorHistory(-5.0, 18.0, 30.0, 50.0)
  },
  {
    macAddr: "AA:BB:CC:DD:EE:09",
    label: "Capteur Ambiant Extérieur",
    rssi: -68,
    temperature: 19.8,
    humidity: 38.5,
    battery: 23,
    temperatureMin: -5.0,
    temperatureMax: 18.0,
    humidityMin: 30.0,
    humidityMax: 50.0,
    alertDelay: 30,
    lastSeen: "2024-07-16T09:15:00Z",
    alertes: true,
    rapports: false,
    actif: false,
    historique: generateSensorHistory(-5.0, 18.0, 30.0, 50.0)
  },
];